import type { ReactElement } from 'react';

export interface EmptyStateProps {
  readonly children: string;
}

export function EmptyState({ children }: EmptyStateProps): ReactElement {
  return <p className="empty-state">{children}</p>;
}
